import { trackModalImpression } from 'shared_critical/tracking/shared/modal_impression';
import { trackLeadText } from 'shared_critical/tracking/shared/leads';
import { getMobileOSType } from "shared_critical/helper.js"
import { generateLeadIdForRCM } from "../../../mortgage/jornaya_lead_id";

export const validationForm = function(modalContainer, property) {
  var $textNumberForm = $(modalContainer).find('form');
  $textNumberForm.validate({
    rules: {
      "phone": {
        required: true,
        phoneUS:  true
      }
    },
    messages: {
      "phone": {
        required: "Please enter your phone number",
        phoneUS:  "Please enter a valid phone number"
      }
    },
    errorPlacement: function(error, element) {
      error.insertAfter(element);
    },
    submitHandler: function() {
      submitTextLead(modalContainer, property);
    }
  });
};

export const submitFromKeypad = function(inputContainer, submitContainer) {
  $(inputContainer).keydown(function(e) {
    if (e.keyCode == 13) {
      $(submitContainer).submit();
    }
  });

  $(submitContainer).on('click', function() {
    $(submitContainer).submit();
  });
};

export const textInputModalOpen = function(modalContainer, omtag) {
  $(modalContainer).on('shown.bs.modal', function () {
    $('body').addClass('modal-open');
    $(this).off('shown.bs.modal');
    trackModalImpression('web:ldp:text-connection', omtag);
  });
};

export const closeTutorial = function(closeButton, modalContainer) {
  $(closeButton).on('click', function(){
    $(modalContainer).modal('hide');
  });
};

var textLeadSubmited = false;

var submitTextLead = function(modalContainer, property) {
  if (textLeadSubmited) return;

  textLeadSubmited = true;

  /* track text lead button position for ldp and qv */
  let leadPlacement = null;

  if(modalContainer === '#textInputModal') {
    leadPlacement = leadSubmittionTracking(modalContainer);
  } else {
    /* LGWEB-159 */
    leadPlacement =  $(modalContainer).find('.submit').data('lead-position');
    /* end LGWEB-159 */
  }

  if(leadPlacement) {
    trackLeadText({ property, leadPlacement }); // track text lead when data-lead-position is present
  }

  if (!MOVE_DATA.leadid_token) generateLeadIdForRCM();

  $.ajax({
    data: getLeadData(modalContainer, property, {}),
    url: "/leads",
    type: 'POST',
    success: function(response) {
      parseResponseAndDisplayThankYou(response, property);
      var hlt_txt_vs_email_ab = MOVE_DATA.ab_hlt_text_vs_email;
      if (hlt_txt_vs_email_ab==="V1" || hlt_txt_vs_email_ab === "V2" || MOVE_DATA.ab_only_txt_mweb === 'V1') {
        $('.email-button').text("Texted").addClass("texted");
      }else{
        $('.text-button').text("Texted").addClass("texted");
      }
      /* LGWEB-978 */
      $('#qv-sticky-text-cta').removeClass('ab-text-gallery');
      $('#qv-sticky-text-cta').removeClass('ab-text');
      /* END LGWEB-978 */
      textLeadSubmited = false;
      /* LGWEB-159 */
        $('.lf-text-wrapper').addClass('texted');
      /* END LGWEB-159 */
    },
    error: function(error) {
      MOVE.Common.addNewRelicLog(
        'textLeadFailure', { error: error}
      );
      showThankyouModal(null, property);
      textLeadSubmited = false;
    }
  });
}

var parseResponseAndDisplayThankYou = function(response, property) {
  try {
    var data = JSON.parse(response.data);
    if(!data.meta || !data.meta.success){
        MOVE.Common.addNewRelicLog(
          'textLeadFailure',
          MOVE.Common.leadErrorMsg(data));
    }
    showThankyouModal(data, property);
  } catch (e) {
    MOVE.Common.addNewRelicLog(
      'textLeadFailure', { exception_msg: e.message}
    );
    showThankyouModal(null, property);
  }
}

function phoneFormatterUS(event){
  event.preventDefault();
  var mask = "(___) ___-____"
  var eventValue = event.target.value;
  var text = "";
  var numbers = [];
  var output = ""
  text = eventValue;
  var theLastPos = 1;
  //get numbers
  for (var i = 0; i < text.length; i++) {
    if (!isNaN(text.charAt(i)) && text.charAt(i) != " ") {
      numbers.push(text.charAt(i));
    }
   }
  //write over mask
  for (var j = 0; j < mask.length; j++) {
    if (mask.charAt(j) == "_") { //replace "_" by a number 
      if (numbers.length == 0){
        output = output + mask.charAt(j);
      }
      else {
        output = output + numbers.shift();
        theLastPos = j + 1;
      }
    } else {
      output = output + mask.charAt(j);
    }
  }
  $(this).val(output);
  if((event.which>=48 && event.which<=57)||event.which==8){
  $(this)[0].setSelectionRange(theLastPos, theLastPos);
  }
}

export const phoneFieldMask = function(event){
  $(".phone").addClass("phoneField");
  phoneFormatterUS.call(this, event);
  $(this).keyup(phoneFormatterUS);
}

export const getLeadData = function(modalContainer, property, options){
  let { pageType, appVersion, mprID, property_id, propertyStatus, listing_id, listingID, listingAddress} = property,
    { isScheduleTour, mobileNumber, stDate, stTime, isStCall } = options,
    $phoneInput = $(modalContainer).find('.form-control.phone'),
    phone = isScheduleTour? mobileNumber : $phoneInput.val(),
    leadData = {
      lead: {
        appVersion,
        os: getMobileOSType(),
        deviceType: getDeviceType(),
        mprID: property_id || mprID,
        phone,
        time: (new Date()).toISOString(),
        listingId: listing_id || listingID,
        propertyStatus: propertyStatus || "",
        listingAddress: listingAddress || "",
        referral: pageType === 'ldp-quickview'? 'quick_view' : '',
        recentSearches: JSON.stringify(MOVE.UserActivity.getRecentSearches()),
        recentViews: JSON.stringify(MOVE.UserActivity.getRecentViews()),
	      isStCall,
      	isScheduleTour,
      	stDate,
        stTime,
        rcm_lead_id: MOVE_DATA.leadid_token
      },
      text_lead: true
    };

  MOVE.Common.cacheInputs('', '', $phoneInput);
  $('.phone').val($phoneInput.val());
  return $.param(leadData);
};

var getDeviceType = function() {
  let { isAndroid, isIPad } = MOVE_DATA,
      isMobile = MOVE.Helper.isMobile();

  switch (true) {
    case isMobile:
      return "phone";
    case isIPad:
      return "ipad";
    case isAndroid:
      return "android tablet";
    default:
      return "other";
  }
}

var showThankyouModal = function(data, property) {
  let monthlyEstimate = $('#monthly_payment_estimate').text();
  $('.mortgage-thankyou-modal-payment .payment').html(monthlyEstimate);
  $("#textThankyouModal").modal("show");
  MOVE.LEAD.Common.dismissModalLeadForm($("#textInputModal"));
  crossSellInit(data, property);
};

var crossSellInit = function(data, property) {
  if (data) {
    var ld = data.meta.params.lead.lead_data;
    var lead_id = data.lead.id;
  } else {
    ld = {};
    lead_id = '';
  }
  let alternate_ld = MOVE.Common.getCachedInputsData() || {};
  var crossSellDidSubmit = false;
  if (!crossSellDidSubmit) {
    MOVE.MORTGAGE.CrossSellThankyouModal.init(Object.assign({}, {
      selector: '#textThankyouModal',
      after_submit: function () { crossSellDidSubmit = true; },
      lead_id: lead_id,
      email: ld.email || alternate_ld.email,
      phone: ld.phone  || alternate_ld.phone,
      first_name: ld.first_name  || alternate_ld.fullName,
      last_name: ld.last_name  || ''
    }, propertyCrossSellValues(property)));
  }
};

var propertyCrossSellValues = function(property) {
  return {
    listing_id: property.listing_id || property.listingID || property.id,
    property_type: property.propertyType,
    price: property.listingPrice,
    street: property.address,
    city: property.listingCity,
    state: property.listingState,
    zip_code: property.listingZip
  }
};


var leadSubmittionTracking = function() {
  let { pageType, propertyStatus } = MOVE_DATA.adobeDTM;
  var leadPosition = '';
  if (pageType=== "ldp-quickview") {
    const qvWrapClasses = $('#qv-wrap').attr("class");
    if(qvWrapClasses.includes('qv-full-view-gallery')) {
      leadPosition = 'photo_gallery';
    } else if(qvWrapClasses.includes('qv-list-gallery')) {
      leadPosition ='photo_list_gallery';
    }
  } else if (pageType === 'ldp') {
    const $galleryModal = $('#ldp-fullscreen-gallery');
    const $galleryCarousel = $galleryModal.find('#mobileFsGalleryCarousel');
    if($galleryModal.hasClass('in')) {
      if($galleryCarousel.hasClass('shown')) {
        leadPosition = 'photo_gallery';
      } else {
        leadPosition = 'photo_list_gallery';
      }
    }
  }
  return `${propertyStatus}:${pageType}:${leadPosition ? leadPosition : 'sticky_footer'}:contact_agent_text`;
}



// WEBPACK FOOTER //
// ./ldp/mobile/views/_text_input_modal_helper.js